'use client';

import a__default, { forwardRef, useCallback } from "react";
import { useId } from "../../utils/hooks/useId.js";
import { FormControl } from "../FormControl/FormControl.js";
import { useLiveAnnouncement } from "../../utils/hooks/useLiveAnnouncement.js";
import { classNames } from "../../utils/styles/classNames.js";
import { input, inputSpacing, wrapper, fakeInput } from "./TextField.css.js";
import { parseProps } from "./utils/parseProps.js";
import { errorAnnouncement } from "./TextField.data.js";
import { renderPrefix } from "./utils/renderPrefix.js";
import { handleAriaDescribedBy } from "./utils/handleAriaDescribedBy.js";
import { renderSuffix } from "./utils/renderSuffix.js";
import { getFakeInputBorderClassName } from "./utils/getFakeInputBorderClassName.js";
import { handleInputType } from "./utils/handleInputType.js";
import { defaultProps } from "./TextField.defaultProps.js";
function TextFieldComponent(props, ref) {
  const { extraContentProps, formControlProps, inputProps } = parseProps(props);
  const {
    dataQa,
    id: inputId,
    inputSize: inputSizeProp,
    onBlur,
    ...restInputProps
  } = inputProps;
  const autoId = useId();
  const isAutoIdNeeded = !inputId || inputId === "";
  const id = isAutoIdNeeded ? autoId : inputId;
  const descriptionId = `chalk-textfield-description-id-${id}`;
  const inputSize = inputSizeProp || defaultProps.inputSize;
  const announce = useLiveAnnouncement();
  const handleBlur = useCallback(
    (event) => {
      if (formControlProps.error) {
        announce(
          errorAnnouncement(
            formControlProps.a11yLabel || formControlProps.label,
            formControlProps.error
          ),
          {
            id: `${id}-error`,
            a11yImportance: "polite"
          }
        );
      }
      onBlur == null ? void 0 : onBlur(event);
    },
    [formControlProps.error, onBlur]
  );
  return /* @__PURE__ */ a__default.createElement(
    FormControl,
    {
      ...formControlProps,
      descriptionId,
      htmlFor: id
    },
    /* @__PURE__ */ a__default.createElement("div", { className: classNames(wrapper, inputSpacing[inputSize]) }, renderPrefix(extraContentProps, formControlProps.disabled), /* @__PURE__ */ a__default.createElement(
      "input",
      {
        ...restInputProps,
        ...handleAriaDescribedBy(
          formControlProps,
          descriptionId,
          inputProps
        ),
        ...handleInputType(inputProps.type),
        "aria-invalid": formControlProps.error ? "true" : void 0,
        "aria-required": formControlProps.required ? "true" : void 0,
        className: input,
        "data-qa": dataQa,
        disabled: formControlProps.disabled,
        id,
        ref,
        onBlur: handleBlur
      }
    ), /* @__PURE__ */ a__default.createElement(
      "div",
      {
        className: classNames(
          fakeInput,
          getFakeInputBorderClassName(formControlProps)
        )
      }
    ), renderSuffix(extraContentProps, formControlProps.disabled))
  );
}
const TextField = /* @__PURE__ */ forwardRef(TextFieldComponent);
export {
  TextField
};
